var version = [0,8,42,0,"g9d1b1e8!"];
